import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { VLogo } from "@/components/VLogo";

const PHONE_HREF = "tel:+306936614442";
const DRAWER_IMG = "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/bpqsxqp4_IMG_0097.webp";

export const Nav = () => {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const solid = scrolled || open || location.pathname !== "/";

  const goTo = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 140);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [
    { id: "welcome", label: t.nav.day },
    { id: "kitchen", label: t.nav.menu },
    { id: "events", label: t.nav.events },
    { id: "gallery", label: t.nav.gallery },
    { id: "reserve", label: t.nav.contact },
  ];

  return (
    <>
      <header className={`nav ${solid ? "nav--solid" : ""} ${open ? "nav--open" : ""}`} data-testid="main-nav">
        <div className="nav__left">
          <button
            className={`nav__burger ${open ? "is-open" : ""}`}
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="nav-burger"
          >
            <span /><span />
          </button>
          <span className={`nav__menu-word ${open ? "is-dark" : ""}`}>menu</span>
        </div>

        <Link to="/" className="nav__brand" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <VLogo height={68} className="nav__logo" />
        </Link>

        <div className="nav__right">
          <div className="lang-toggle" data-testid="lang-toggle">
            <button
              className={`lang-toggle__btn ${lang === "en" ? "is-active" : ""}`}
              onClick={() => setLang("en")}
              data-testid="lang-en"
            >
              EN
            </button>
            <span className="lang-toggle__sep">/</span>
            <button
              className={`lang-toggle__btn ${lang === "gr" ? "is-active" : ""}`}
              onClick={() => setLang("gr")}
              data-testid="lang-gr"
            >
              ΕΛ
            </button>
          </div>
          <a href={PHONE_HREF} className="nav__cta" data-testid="nav-reserve-cta">
            {t.nav.reserve}
          </a>
        </div>
      </header>

      <div className={`mobile-menu ${open ? "is-open" : ""}`} data-testid="mobile-menu">
        <button
          className="mobile-menu__close"
          onClick={() => setOpen(false)}
          aria-label="Close menu"
          data-testid="mobile-menu-close"
        >
          <span /><span />
        </button>
        <div className="mobile-menu__inner">
          {links.map((l, i) => (
            <button
              key={l.id}
              className="mobile-menu__link"
              style={{ transitionDelay: open ? `${0.07 * i + 0.15}s` : "0s" }}
              onClick={() => goTo(l.id)}
              data-testid={`mobile-link-${l.id}`}
            >
              <span className="mobile-menu__num">0{i + 1}</span>
              {l.label}
            </button>
          ))}
          <Link
            to="/menu"
            className="mobile-menu__link"
            style={{ transitionDelay: open ? "0.5s" : "0s" }}
            onClick={() => setOpen(false)}
            data-testid="mobile-link-fullmenu"
          >
            <span className="mobile-menu__num">06</span>
            {t.nav.fullMenu}
          </Link>
          <a href={PHONE_HREF} className="btn btn--gold mobile-menu__cta" data-testid="mobile-reserve-cta">
            {t.nav.reserve} · +30 6936 61 44 42
          </a>
          <p className="mobile-menu__foot">VAMMOS · sand life · Varkiza · 09:00 — 02:00</p>
        </div>
        <figure className="mobile-menu__visual">
          <img src={DRAWER_IMG} alt="Varkiza" />
          <figcaption>varkiza, athens riviera</figcaption>
        </figure>
      </div>
    </>
  );
};

export default Nav;
